import "./import-modules";

import bootstrap from 'bootstrap';
import validate from 'jquery-validation';

// datetimepicker
import 'tempusdominus-bootstrap-4';

import './scss/main.scss';
// import so that all get watched
import "./scss/_variables.scss";
import "./scss/_global.scss";

jQuery(document).ready(function () {

    var widget, initAddressFinder = function() {
        widget = new AddressFinder.Widget(
            document.getElementById('address-finder'),
            'YEWLN6AM9TDP4F7VHQJG',
            'NZ', {}
        );
        widget.on('address:select', function(fullAddress, metaData) {
            document.getElementById('location').value = fullAddress;
            document.getElementById('latitude').value = metaData.y;
            document.getElementById('longitude').value = metaData.x;
        });

    };

    function downloadAddressFinder() {
        var script = document.createElement('script');
        script.src = 'https://api.addressfinder.io/assets/v3/widget.js';
        script.async = true;
        script.onload = initAddressFinder;
        document.body.appendChild(script);
    };
    var addr_find_el=document.getElementById('address-finder');
    if ( addr_find_el ) {
        downloadAddressFinder(addr_find_el);
    }

    var kids=jQuery("#about-slide .carousel-inner").children().length;
    var pick = Math.floor(Math.random() * kids);
    jQuery('#about-slide .carousel-inner article:eq('+pick+')').addClass('active');
    var ind = jQuery("#about-slide .carousel-indicators");
    for ( var i=1; i<= kids;i++) {
        ind.append('<li data-target="#about-slide" data-slide-to="'+i+'"></li>');
    }
    // Add missing classes to xmenu generated items
    // If there are multiple navbar dropdowns use nbd-x to make them unique

    jQuery('li.nav-item div.dropdown-menu').siblings("a").each(function (dropdownNumber) {
        jQuery(this).addClass("dropdown-toggle");
        jQuery(this).prop("id", "nbd-" + dropdownNumber);
        jQuery(this).attr({
            "role": "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
        })
        jQuery(this).siblings('div.dropdown-menu').attr("aria-labelledby", "nbd-" + dropdownNumber);
    });

    // Function to scroll to top of page.
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 50) {
            jQuery('#back-to-top').fadeIn('slow');
        } else {
            jQuery('#back-to-top').fadeOut('slow', function () {
                jQuery('#back-to-top').attr('style', 'display: none !important');
            });
        }
    });
    // Scroll body to 0px on click
    jQuery('#back-to-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });

    // Hide default error messages
    jQuery.validator.messages.required = '';

    jQuery('.validate').validate({
        highlight: function (element) {
            jQuery(element).closest('.form-control').addClass('is-invalid');
        },
        unhighlight: function (element) {
            jQuery(element).closest('.form-control').removeClass('is-invalid');
        },
        errorElement: 'span',
        errorClass: 'label label-danger',
        errorPlacement: function (error, element) {
            if (element.parent('.input-group').length) {
                error.insertAfter(element.parent());
            } else {
                error.insertAfter(element);
            }
        }
    });

    // Boostrap 4 datetimepicker
    // set icons to use Font Awesome 5
    jQuery.fn.datetimepicker.Constructor.Default = jQuery.extend({}, jQuery.fn.datetimepicker.Constructor.Default, {
        format: 'D MMM YYYY',
        icons: {
            time: 'fa fa-clock',
            date: 'fa fa-calendar',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-calendar-check-o',
            clear: 'fa fa-trash',
            close: 'fa fa-times'
        }
    });

    $('.datetimepicker-input').datetimepicker();
    // Add time to date_open
    $('#date_open').datetimepicker('format', 'd MMM YYYY hh:mm a');


    // File input - show filename once selected
    jQuery('div.custom-file .custom-file-input').on('change', function () {
        $(this).next('.custom-file-label').html($(this)[0].files[0].name);
    })

    
    // select list hide/show optional div - /programme/exhibitors_submission.cfm
    jQuery("#theme").on('change', function (e) {
        var isSatellite = jQuery(this).val() === 'Satellite';
        var target = jQuery(this).data('target');
        jQuery('#collapseArea').collapse(isSatellite ? 'show' : 'hide');
        jQuery(target).find('select').attr('required', isSatellite ? 'required' : '')

    });

    // Large modal carousel
    $('#gallery').on('slide.bs.carousel', function (e) {
        var title=jQuery(e.relatedTarget).find('img').data('title');
        title=title.replace(/;/g,' &bull; ')
        $('#gallery-modal-title').html(title);
     })

});